// Kleine Anzeige-Helfer (keine Geschäftslogik).

export function credits(n: number): string {
  return `${n.toLocaleString("de-DE")} cr`;
}

export function relativeTime(input: string | Date): string {
  const then = typeof input === "string" ? new Date(input).getTime() : input.getTime();
  const diff = Date.now() - then;
  if (!Number.isFinite(diff)) return "";
  const sec = Math.round(diff / 1000);
  if (sec < 60) return "gerade eben";
  const min = Math.round(sec / 60);
  if (min < 60) return `vor ${min} min`;
  const h = Math.round(min / 60);
  if (h < 24) return `vor ${h} h`;
  const d = Math.round(h / 24);
  return `vor ${d} T.`;
}

export function titleCase(s: string): string {
  return s.replace(/(^|[-_ ])(\w)/g, (_, p1: string, p2: string) => (p1 ? " " : "") + p2.toUpperCase());
}

/**
 * D164: kompakte Dauer als Stoppuhr-Anzeige (`m:ss`, ab einer Stunde `h:mm:ss`) für die
 * Job-Zeitspalte. Sekundengenau (floor); negative/ungültige Eingaben → "0:00".
 */
export function duration(ms: number): string {
  const totalSec = Number.isFinite(ms) && ms > 0 ? Math.floor(ms / 1000) : 0;
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  const ss = String(s).padStart(2, "0");
  return h > 0 ? `${h}:${String(m).padStart(2, "0")}:${ss}` : `${m}:${ss}`;
}
